import React, { useState } from 'react';
import api from '../../services/api';

const PRESET_AMOUNTS = [10, 25, 50, 100, 200];
const PAYMENT_METHODS = [
  { value: 'capitalist', label: '💳 Capitalist', sub: 'Tarjeta, USDT, crypto' },
  { value: 'btc',        label: '₿ Bitcoin',     sub: 'Lightning o on-chain' },
  { value: 'usdt_trc20', label: '₮ USDT TRC-20', sub: 'Directo a wallet' },
  { value: 'zelle',      label: '💵 Zelle',       sub: 'Transferencia manual' },
];

function CodeDisplay({ code, amount }) {
  const [copied, setCopied] = useState(false);
  const copy = () => { navigator.clipboard.writeText(code); setCopied(true); setTimeout(() => setCopied(false), 2000); };
  return (
    <div style={{ background: 'linear-gradient(135deg,#0f0d0b,#1a1008)', borderRadius: 20, padding: 32, textAlign: 'center', color: '#fff' }}>
      <div style={{ fontSize: 44, marginBottom: 12 }}>🎁</div>
      <div style={{ fontFamily: 'Georgia,serif', fontSize: 32, color: '#4ade80', fontWeight: 700, marginBottom: 4 }}>${amount} USD</div>
      <div style={{ fontSize: 13, color: 'rgba(255,255,255,.5)', marginBottom: 24 }}>Gift Card Guarapo</div>
      <div style={{ background: 'rgba(255,255,255,.08)', borderRadius: 12, padding: '16px 20px', marginBottom: 16, border: '1px solid rgba(255,255,255,.1)' }}>
        <div style={{ fontFamily: 'monospace', fontSize: 28, fontWeight: 700, letterSpacing: 4 }}>{code}</div>
      </div>
      <button onClick={copy} style={{ padding: '10px 24px', borderRadius: 8, border: 'none', background: copied?'#2d6a4f':'#4ade80', color: '#080808', fontSize: 13, fontWeight: 800, cursor: 'pointer' }}>
        {copied ? '✓ Copiado' : 'Copiar código'}
      </button>
      <div style={{ fontSize: 11, color: 'rgba(255,255,255,.3)', marginTop: 16 }}>Comparte este código con el receptor para que lo canjee en Guarapo</div>
    </div>
  );
}

export default function GiftCards() {
  const [tab, setTab] = useState('buy');
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(null);
  const [myCards, setMyCards] = useState([]);
  const [redeemCode, setRedeemCode] = useState('');
  const [redeemResult, setRedeemResult] = useState(null);

  const [form, setForm] = useState({
    amount: 25, customAmount: '', useCustom: false,
    delivery: 'both',
    recipient_email: '', recipient_name: '', personal_message: '',
    payment_method: 'capitalist',
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const finalAmount = form.useCustom ? parseFloat(form.customAmount) || 0 : form.amount;

  const inputStyle = { width: '100%', padding: '11px 14px', border: '1px solid #e2dbd0', borderRadius: 10, fontSize: 14, outline: 'none', background: '#faf8f5', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: 10.5, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: '#7a7060', marginBottom: 6 };

  const loadMyCards = async () => {
    try { const r = await api.get('/api/v1/giftcards/my'); setMyCards(Array.isArray(r.data) ? r.data : []); } catch {}
  };

  const handleBuy = async () => {
    if (!finalAmount || finalAmount < 5) { setError('Monto mínimo: $5'); return; }
    if (form.delivery !== 'code' && !form.recipient_email) { setError('Email del receptor requerido'); return; }
    setLoading(true); setError('');
    try {
      const res = await api.post('/api/v1/giftcards/purchase', {
        amount_usd: finalAmount,
        recipient_email: form.recipient_email || null,
        recipient_name: form.recipient_name || null,
        personal_message: form.personal_message || null,
        payment_method: form.payment_method,
        delivery_mode: form.delivery,
      });
      const card = res.data;
      if (card.payment_url && ['capitalist', 'btc'].includes(form.payment_method)) {
        setSuccess({ type: 'redirect', code: card.code, amount: finalAmount, payment_url: card.payment_url, method: form.payment_method });
      } else {
        setSuccess({ type: 'manual', code: card.code, amount: finalAmount, method: form.payment_method });
      }
      setStep(3);
    } catch (e) {
      setError(e.response?.data?.detail || 'Error al crear la gift card');
    } finally { setLoading(false); }
  };

  const handleRedeem = async () => {
    if (!redeemCode.trim()) { setError('Introduce el código'); return; }
    setLoading(true); setError('');
    try {
      const res = await api.post('/api/v1/giftcards/redeem', { code: redeemCode.trim().toUpperCase() });
      setRedeemResult(res.data);
    } catch (e) {
      setError(e.response?.data?.detail || 'Código inválido o ya canjeado');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ maxWidth: 560, margin: '0 auto' }}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 26, margin: '0 0 4px' }}>Gift Cards</h1>
        <p style={{ fontSize: 13, color: '#7a7060' }}>Regala saldo Guarapo a quien quieras</p>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, background: '#f0ebe2', borderRadius: 10, padding: 4, marginBottom: 24 }}>
        {[['buy','🎁 Comprar'],['redeem','✨ Canjear'],['my','📋 Mis cards']].map(([t,l]) => (
          <button key={t} onClick={() => { setTab(t); setStep(1); setError(''); setSuccess(null); if(t==='my') loadMyCards(); }}
            style={{ flex:1, padding:'8px', borderRadius:7, border:'none', cursor:'pointer', fontSize:13, fontWeight:600, background:tab===t?'#fff':'transparent', color:tab===t?'#0f0d0b':'#7a7060' }}>
            {l}
          </button>
        ))}
      </div>

      {/* BUY */}
      {tab === 'buy' && (
        <>
          {step < 3 && (
            <div style={{ display:'flex', gap:8, marginBottom:20 }}>
              {['Monto','Destinatario','Pago'].map((s,i) => (
                <div key={i} style={{ flex:1, display:'flex', alignItems:'center', gap:6 }}>
                  <div style={{ width:22, height:22, borderRadius:'50%', background:step>i+1?'#2d6a4f':step===i+1?'#c94a1e':'#e2dbd0', display:'flex', alignItems:'center', justifyContent:'center', fontSize:10, fontWeight:700, color:step>=i+1?'#fff':'#7a7060', flexShrink:0 }}>
                    {step > i+1 ? '✓' : i+1}
                  </div>
                  <div style={{ fontSize:11, fontWeight:600, color:step===i+1?'#0f0d0b':'#7a7060' }}>{s}</div>
                  {i<2 && <div style={{ flex:1, height:2, background:step>i+1?'#2d6a4f':'#e2dbd0' }}/>}
                </div>
              ))}
            </div>
          )}

          {error && <div style={{ background:'#faeef4', borderRadius:8, padding:'9px 14px', marginBottom:14, fontSize:13, color:'#9b2c5e' }}>⚠ {error}</div>}

          {step === 1 && (
            <div style={{ background:'#fff', border:'1px solid #e2dbd0', borderRadius:16, padding:24 }}>
              <div style={{ fontFamily:'Georgia,serif', fontSize:16, marginBottom:18 }}>¿Cuánto quieres regalar?</div>
              <div style={{ display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:8, marginBottom:16 }}>
                {PRESET_AMOUNTS.map(a => (
                  <button key={a} onClick={() => { set('amount',a); set('useCustom',false); }}
                    style={{ padding:'12px 6px', borderRadius:10, border:`2px solid ${!form.useCustom&&form.amount===a?'#c94a1e':'#e2dbd0'}`, background:!form.useCustom&&form.amount===a?'#fdf4f0':'#fff', fontSize:14, fontWeight:700, cursor:'pointer', color:!form.useCustom&&form.amount===a?'#c94a1e':'#0f0d0b' }}>
                    ${a}
                  </button>
                ))}
              </div>
              <div style={{ marginBottom:20 }}>
                <label style={labelStyle}>MONTO PERSONALIZADO</label>
                <div style={{ position:'relative' }}>
                  <span style={{ position:'absolute', left:14, top:'50%', transform:'translateY(-50%)', color:'#7a7060', fontSize:16 }}>$</span>
                  <input type="number" placeholder="Otro monto..." style={{ ...inputStyle, paddingLeft:30 }}
                    value={form.customAmount} onChange={e => { set('customAmount',e.target.value); set('useCustom',true); }} onFocus={() => set('useCustom',true)} />
                </div>
                <div style={{ fontSize:11, color:'#b0a090', marginTop:4 }}>Mínimo $5 · Máximo $500</div>
              </div>
              {finalAmount > 0 && (
                <div style={{ background:'linear-gradient(135deg,#0f0d0b,#1a1008)', borderRadius:12, padding:'14px 18px', marginBottom:20, display:'flex', alignItems:'center', gap:12 }}>
                  <span style={{ fontSize:28 }}>🎁</span>
                  <div>
                    <div style={{ fontFamily:'Georgia,serif', fontSize:22, color:'#4ade80', fontWeight:700 }}>${finalAmount} USD</div>
                    <div style={{ fontSize:11, color:'rgba(255,255,255,.4)' }}>Gift Card Guarapo</div>
                  </div>
                </div>
              )}
              <button onClick={() => { if(!finalAmount||finalAmount<5){setError('Monto mínimo $5');return;} setError('');setStep(2); }}
                style={{ width:'100%', padding:'13px', borderRadius:10, border:'none', background:'#c94a1e', color:'#fff', fontSize:15, fontWeight:700, cursor:'pointer' }}>
                Continuar →
              </button>
            </div>
          )}

          {step === 2 && (
            <div style={{ background:'#fff', border:'1px solid #e2dbd0', borderRadius:16, padding:24 }}>
              <div style={{ fontFamily:'Georgia,serif', fontSize:16, marginBottom:18 }}>¿Cómo la entregamos?</div>
              <div style={{ marginBottom:18 }}>
                <label style={labelStyle}>MODO DE ENTREGA</label>
                <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                  {[{v:'email',l:'📧 Enviar por email al receptor'},{v:'code',l:'📋 Solo darme el código a mí'},{v:'both',l:'📧 + 📋 Email al receptor y código para mí'}].map(m => (
                    <button key={m.v} onClick={() => set('delivery',m.v)}
                      style={{ padding:'11px 14px', borderRadius:10, border:`2px solid ${form.delivery===m.v?'#c94a1e':'#e2dbd0'}`, background:form.delivery===m.v?'#fdf4f0':'#fff', fontSize:13, cursor:'pointer', textAlign:'left', fontWeight:form.delivery===m.v?700:400, color:form.delivery===m.v?'#c94a1e':'#0f0d0b' }}>
                      {m.l}
                    </button>
                  ))}
                </div>
              </div>
              {form.delivery !== 'code' && (
                <>
                  {[{key:'recipient_email',label:'EMAIL DEL RECEPTOR',placeholder:'familia@email.com',type:'email'},{key:'recipient_name',label:'NOMBRE (opcional)',placeholder:'María García'}].map(f => (
                    <div key={f.key} style={{ marginBottom:14 }}>
                      <label style={labelStyle}>{f.label}</label>
                      <input type={f.type||'text'} style={inputStyle} placeholder={f.placeholder} value={form[f.key]} onChange={e => set(f.key,e.target.value)} />
                    </div>
                  ))}
                  <div style={{ marginBottom:18 }}>
                    <label style={labelStyle}>MENSAJE PERSONAL (opcional)</label>
                    <textarea style={{ ...inputStyle, minHeight:70, resize:'vertical' }} placeholder="¡Feliz cumpleaños! Con amor desde..." value={form.personal_message} onChange={e => set('personal_message',e.target.value)} maxLength={200} />
                    <div style={{ fontSize:11, color:'#b0a090', textAlign:'right' }}>{form.personal_message.length}/200</div>
                  </div>
                </>
              )}
              <div style={{ marginBottom:20 }}>
                <label style={labelStyle}>MÉTODO DE PAGO</label>
                <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                  {PAYMENT_METHODS.map(m => (
                    <button key={m.value} onClick={() => set('payment_method',m.value)}
                      style={{ padding:'11px 14px', borderRadius:10, border:`2px solid ${form.payment_method===m.value?'#c94a1e':'#e2dbd0'}`, background:form.payment_method===m.value?'#fdf4f0':'#fff', fontSize:13, cursor:'pointer', textAlign:'left', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                      <span style={{ fontWeight:form.payment_method===m.value?700:400, color:form.payment_method===m.value?'#c94a1e':'#0f0d0b' }}>{m.label}</span>
                      <span style={{ fontSize:11, color:'#7a7060' }}>{m.sub}</span>
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ display:'flex', gap:10 }}>
                <button onClick={() => {setStep(1);setError('');}} style={{ flex:1, padding:'12px', borderRadius:10, border:'1px solid #e2dbd0', background:'#fff', fontSize:14, cursor:'pointer' }}>← Atrás</button>
                <button onClick={handleBuy} disabled={loading} style={{ flex:2, padding:'12px', borderRadius:10, border:'none', background:loading?'#e2dbd0':'#c94a1e', color:'#fff', fontSize:14, fontWeight:700, cursor:loading?'not-allowed':'pointer' }}>
                  {loading ? 'Procesando...' : `Comprar $${finalAmount} →`}
                </button>
              </div>
            </div>
          )}

          {step === 3 && success && (
            <div>
              {success.type === 'redirect' ? (
                <div style={{ background:'#fff', border:'1px solid #e2dbd0', borderRadius:16, padding:28, textAlign:'center' }}>
                  <div style={{ fontSize:48, marginBottom:10 }}>💳</div>
                  <h3 style={{ fontFamily:'Georgia,serif', fontSize:20, marginBottom:8 }}>Completa el pago</h3>
                  <p style={{ fontSize:13, color:'#7a7060', marginBottom:16 }}>Se abrió Capitalist. Al confirmar el pago, la gift card se activa automáticamente.</p>
                  <a href={success.payment_url} target="_blank" rel="noopener noreferrer"
                    style={{ display:'inline-block', padding:'12px 24px', borderRadius:10, background:'#c94a1e', color:'#fff', fontSize:14, fontWeight:700, textDecoration:'none', marginBottom:14 }}>
                    Abrir página de pago →
                  </a>
                  <div style={{ background:'#f9f6f1', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#7a7060' }}>
                    Código: <b style={{ fontFamily:'monospace', fontSize:14 }}>{success.code}</b> — se activa al pagar
                  </div>
                </div>
              ) : (
                <>
                  <CodeDisplay code={success.code} amount={success.amount} />
                  <div style={{ marginTop:14, background:'#fef3e2', borderRadius:10, padding:'12px 16px', fontSize:13, color:'#b45309' }}>
                    ⚡ Pago manual — contacta soporte@guarapo.app con el comprobante para activar la gift card.
                  </div>
                </>
              )}
            </div>
          )}
        </>
      )}

      {/* REDEEM */}
      {tab === 'redeem' && (
        <div style={{ background:'#fff', border:'1px solid #e2dbd0', borderRadius:16, padding:24 }}>
          {redeemResult ? (
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:52, marginBottom:12 }}>✅</div>
              <h3 style={{ fontFamily:'Georgia,serif', fontSize:22, marginBottom:8, color:'#2d6a4f' }}>¡Gift card canjeada!</h3>
              <div style={{ fontFamily:'Georgia,serif', fontSize:32, color:'#c94a1e', marginBottom:8 }}>${redeemResult.amount_usd}</div>
              <p style={{ fontSize:13, color:'#7a7060', marginBottom:20 }}>Saldo añadido a tu wallet Guarapo.</p>
              <button onClick={() => { setRedeemResult(null); setRedeemCode(''); setTab('buy'); }}
                style={{ padding:'10px 24px', borderRadius:8, border:'none', background:'#c94a1e', color:'#fff', fontSize:14, fontWeight:700, cursor:'pointer' }}>
                Enviar una remesa →
              </button>
            </div>
          ) : (
            <>
              <div style={{ fontFamily:'Georgia,serif', fontSize:16, marginBottom:18 }}>Canjear gift card</div>
              {error && <div style={{ background:'#faeef4', borderRadius:8, padding:'9px 14px', marginBottom:14, fontSize:13, color:'#9b2c5e' }}>⚠ {error}</div>}
              <div style={{ marginBottom:20 }}>
                <label style={labelStyle}>CÓDIGO DE GIFT CARD</label>
                <input style={{ ...inputStyle, fontFamily:'monospace', fontSize:22, fontWeight:700, textAlign:'center', letterSpacing:4, textTransform:'uppercase' }}
                  placeholder="XXXX-XXXX-XXXX" value={redeemCode} onChange={e => setRedeemCode(e.target.value.toUpperCase())} />
              </div>
              <button onClick={handleRedeem} disabled={loading||!redeemCode.trim()}
                style={{ width:'100%', padding:'13px', borderRadius:10, border:'none', background:(loading||!redeemCode.trim())?'#e2dbd0':'#c94a1e', color:'#fff', fontSize:15, fontWeight:700, cursor:(loading||!redeemCode.trim())?'not-allowed':'pointer' }}>
                {loading ? 'Verificando...' : '✨ Canjear gift card'}
              </button>
            </>
          )}
        </div>
      )}

      {/* MY CARDS */}
      {tab === 'my' && (
        myCards.length === 0 ? (
          <div style={{ background:'#fff', border:'1px solid #e2dbd0', borderRadius:14, padding:48, textAlign:'center' }}>
            <div style={{ fontSize:40, marginBottom:12 }}>🎁</div>
            <div style={{ fontFamily:'Georgia,serif', fontSize:18, marginBottom:8 }}>Sin gift cards todavía</div>
            <button onClick={() => setTab('buy')} style={{ padding:'10px 24px', borderRadius:8, border:'none', background:'#c94a1e', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', marginTop:12 }}>
              Comprar gift card
            </button>
          </div>
        ) : myCards.map((card, i) => (
          <div key={i} style={{ background:'#fff', border:'1px solid #e2dbd0', borderRadius:12, padding:'16px 18px', marginBottom:8, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <div>
              <div style={{ fontFamily:'monospace', fontSize:15, fontWeight:700, letterSpacing:2, marginBottom:4 }}>{card.code}</div>
              <div style={{ fontSize:12, color:'#7a7060' }}>{card.recipient_email && `Para: ${card.recipient_email}`}</div>
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ fontFamily:'Georgia,serif', fontSize:20, color:'#c94a1e', fontWeight:700 }}>${card.amount_usd}</div>
              <div style={{ fontSize:11, padding:'2px 8px', borderRadius:20, background:card.status==='active'?'#eaf4ef':'#f0ebe2', color:card.status==='active'?'#2d6a4f':'#7a7060', fontWeight:600 }}>
                {card.status === 'active' ? 'Activa' : 'Canjeada'}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
